import React from "react";
import { useLoaderData } from "react-router-dom";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";

const ProjectDetails = () => {
  const project = useLoaderData();

  return (
    <div>
      <h1 className="text-center text-4xl font-semibold mt-20">
        Project <span className="text-indigo-600 text-5xl">Details</span>
      </h1>
      <div>
        <div className="grid gap-6 grid-cols-1 lg:grid-cols-12">
          <div className="my-10 grid lg:col-span-8 ml-8">
            <Carousel infiniteLoop autoPlay className="text-center">
              <div className="">
                <img src={project.images?.img_1} alt="" />
              </div>
              <div className="">
                <img src={project.images?.img_2} alt="" />
              </div>
              <div className="">
                <img src={project.images?.img_3} alt="" />
              </div>
              <div className="">
                <img src={project.images?.img_4} alt="" />
              </div>
              <div className="">
                <img src={project.images?.img_5} alt="" />
              </div>
              <div className="">
                <img src={project.images?.img_6} alt="" />
              </div>
              <div className="">
                <img src={project.images?.img_7} alt="" />
              </div>
              <div className="">
                <img src={project.images?.img_8} alt="" />
              </div>
              <div className="">
                <img src={project.images?.img_9} alt="" />
              </div>
            </Carousel>
          </div>
          <div className="my-10 grid lg:col-span-4 mr-12">
            <h1 className="text-2xl">
              Name of Project:{" "}
              <span className="text-indigo-500 font-semibold text-3xl">
                {project.project_name}
              </span>
            </h1>
            <p className="text-md mt-2 text-gray-400">- {project.title}</p>
            <h5 className="text-xl mt-6 mb-2 ">Features:</h5>
            <p className="text-gray-400 mb-2">✔ {project?.details?.d1}</p>
            <p className="text-gray-400 mb-2">✔ {project?.details?.d2}</p>
            <p className="text-gray-400 mb-2">✔ {project?.details?.d3}</p>
            <p className="text-gray-400 mb-2">✔ {project?.details?.d4}</p>
            <p className="text-gray-400 mb-2">✔ {project?.details?.d5}</p>
            <p className="text-gray-400 mb-2">✔ {project?.details?.d6}</p>
            <p className="text-gray-400 mb-2">✔ {project?.details?.d7}</p>
            {project.details.d8 && (
              <p className="text-gray-400 mb-2">✔ {project?.details?.d8}</p>
            )}
            {project.details.d9 && (
              <p className="text-gray-400 ">✔ {project?.details?.d9}</p>
            )}
            <h5 className="text-xl mt-6 mb-2 ">
              Technologies used for the project:
            </h5>
            <p className="text-gray-400 mb-2">- {project?.technologies}</p>
            <div>
              <a href={project?.git_client} target="_blank">
                <button className="mr-3 px-4 py-1    rounded-md border-2 border-indigo-700 transition duration-500 hover:bg-indigo-600 mt-8 font-semibold text-lg">
                  Github Client Code
                </button>
              </a>
              <a href={project?.git_server} target="_blank">
                <button className="mr-3 px-4 py-1    rounded-md border-2 border-indigo-700 transition duration-500 hover:bg-indigo-600 mt-8 font-semibold text-lg">
                  Github Server Code
                </button>
              </a>
              <a href={project?.web_link} target="_blank">
                <button className="px-4 py-1     rounded-md border-2 border-indigo-700 transition duration-500 hover:bg-indigo-600 mt-8 font-semibold text-lg">
                  Live Site
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectDetails;
